<template>
  <div ref="chart">
    <Chart :height="height" :id="id" :option="option" :width="width" :extendData="extendData"></Chart>
  </div>
</template>

<script>
import Chart from '@/components/echarts/Chart';

export default {
  name: "ServerUsageChart",
  components: {Chart},
  props: {
    data: {},
    extendData: null,
  },
  data() {
    return {
      id: "lineChart",
      width: '100%',
      height: '100%',
      option: {},
    };
  },
  watch: {
    data: {
      immediate:true,
      handler(){
        this.getOption()
      },
      deep: true, //对象内部属性的监听
    }
  },
  created() {
    this.getOption()
  },
  mounted() {
    this.getOption()
  },
  methods: {
    getOption: function () {
      this.option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            label: {
              show: false,
              backgroundColor: 'rgba(0,0,0,0)',
              color: '#556677',
              borderColor: 'rgba(0,0,0,0)',
              shadowColor: 'rgba(0,0,0,0)',
              shadowOffsetY: 0
            },
            lineStyle: {
              width: 0
            }
          },
          backgroundColor: 'rgba(0,0,0,0.5)',
          textStyle: {
            color: '#fff'
          },
          padding: [10, 10],
          extraCssText: 'box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)'
        },
        grid: {
          top: '10%',
          right: '15%',
          left: '15%',
          bottom: '20%'
        },
        xAxis: [{
          type: 'category',
          data: this.data.time,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            rotate: 30,
            interval: 0,
            textStyle: {
              color: '#fff'
            },
            // 默认x轴字体大小
            fontSize: 12,
            // margin:文字到x轴的距离
            margin: 15
          },
          boundaryGap: false
        }],
        yAxis: [{
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: 'rgba(11, 197, 159, 1)'
            },
            formatter: '{value}'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: 'rgba(73, 164, 243, .2)'
            }
          },
        },
        ],
        series: [{
          name: '使用率',
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0, color: 'rgba(11, 197, 159, 1)' // 0% 处的颜色
              }, {
                offset: 1, color: 'rgba(11, 197, 159, 0.01)' // 100% 处的颜色
              }],
              global: false // 缺省为 false
            }
          },
          type: 'line',
          data: this.data.valueArray,
          symbolSize: 1,
          symbol: 'circle',
          smooth: true,
          yAxisIndex: 0,
          showSymbol: false,
          lineStyle: {
            normal: {
              color: 'rgba(11, 197, 159, 1)',
            }
          },
          itemStyle: {
            normal: {
              color: 'rgba(16, 142, 233, 1)',
              borderColor: 'rgba(16, 142, 233, 1)'
            }
          }
        }]
      };
    },
  },
}
</script>

<style scoped>

</style>
